import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { ListTraderModel } from '../../models/list-trader.model';
import { ShareholderAccountModel } from '../../models/shareholder-account.model';
import { TraderSummaryModel } from '../../models/trader-summary.model';
import { TraderModel } from '../../models/trader.model';
import { TradersShareInfoModel } from '../../models/traders-share-info.model';
import { TransactionModel } from '../../models/transaction.model';

@Injectable({
    providedIn: 'root'
})
export class TradersResource extends BaseEntityResource<TraderModel, TraderSummaryModel, ListTraderModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'traders' }));
    }

    /**
     * Returns all tenants.
     */
    getAccounts(traderId: string): Observable<ApiResponseModel<ShareholderAccountModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<ShareholderAccountModel[]>>(this.getUrl(`${traderId}/accounts`));
    }

    /**
     * Gets the transactions of a specific trader
     * @param traderId ID of the trader.
     */
    getTransactions(traderId: string): Observable<ApiResponseModel<TransactionModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<TransactionModel[]>>(this.getUrl(`${traderId}/transactions`));
    }

    /**
     * Returns share statistics for a specific trader.
     * @param traderId Trader ID.
     */
    getShareStatistics(traderId: string): Observable<ApiResponseModel<TradersShareInfoModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<TradersShareInfoModel[]>>(this.getUrl(`${traderId}/share-statistics`));
    }
}
